(function(){
  if(!('IntersectionObserver' in window)) return;

  // 遅延読み込みしたいモジュールだけ、必要になったら1行ずつ足す
  var loaders = {
    // 'logoBar': () => import('{{ "mod-logo-bar.js" | asset_url }}'),
    // 'search':  () => import('{{ "mod-search.js"    | asset_url }}'),
  };

  // 何も設定されていなければ一切何もしない（オーバーヘッド無し）
  if(Object.keys(loaders).length === 0) return;

  var io = new IntersectionObserver(async function(entries){
    for(const e of entries){
      if(!e.isIntersecting) continue;
      var el = e.target;
      io.unobserve(el);
      var key = el.dataset.module;
      if(!key || !loaders[key]) continue;
      try{
        var mod = await loaders[key]();
        if(mod && typeof mod.default === 'function') mod.default(el);
      }catch(_){}
    }
  }, { rootMargin: '200px 0px' });

  // 対象は data-module のみ。不要な監視もしない
  document.querySelectorAll('[data-module]').forEach(function(el){
    var key = el.dataset.module;
    if(loaders[key]) io.observe(el);
  });
})();
